import type { SentryModule } from '../types';

export const CONTAINER_MODULE_MAP: Readonly<
  Partial<Record<string, SentryModule>>
> = {
  LOGIN: 'login',
  SIGNUP: 'signup',
  FORGOT_PASSWORD: 'auth',
  RESET_PASSWORD: 'auth',
  VERIFY_EMAIL: 'auth',
  VERIFY_PASSWORD: 'auth',
  VERIFY_OTP: 'auth',
  VERIFY_G2FA: 'auth',
  SUMMARY: 'home',
  ANALYTICS_V2: 'insights',
  TRANSACTIONS: 'payments',
  TIMELINE: 'payments',
  PAYMENT_LINKS: 'payment_links',
  PAYMENT_LINK_DESCRIPTION: 'payment_links',
  PAYMENT_FORMS: 'payment_forms',
  PAYMENT_BUTTONS: 'payment_buttons',
  PRODUCT_LINKS: 'payment_buttons',
  SETTLEMENTS: 'settlements',
  SETTLEMENT_DETAILS: 'settlements',
  SETTLEMENT_RECON_DETAILS: 'settlements',
  SETTLEMENT_BANK_DETAILS: 'settlements',
  REPORTS: 'reports',
  SETTINGS: 'settings',
  PAYMENT_METHODS: 'settings',
  NOTIFICATIONS: 'settings',
  BRANDING: 'customisation',
  DEVELOPERS: 'developers',
  API_KEYS: 'developers',
  WEBHOOKS: 'developers',
  EASY_SPLIT: 'easy_split',
  EASY_SPLIT_DETAILS: 'easy_split',
  CUSTOMERS: 'customers',
  SUBSCRIPTIONS: 'subscriptions',
  SUBSCRIPTION_DETAILS: 'subscriptions',
  OFFERS: 'offers',
  OFFERS_DESCRIPTION: 'offers',
  OFFERS_V2_CREATE: 'offers',
  OFFERS_DESCRIPTION_V2: 'offers',
  CHECKOUT_ONE: 'one_click_checkout',
  RISKSHIELD: 'risk_shield',
  DISPUTE_DETAILS: 'disputes',
  REFUNDS_DETAIL: 'refunds',
  ORDERS_DESCRIPTION: 'orders',
  SOFTPOS: 'softpos',
  COLLECTION_POINT_DETAILS: 'softpos',
  APPS: 'apps',
  WORKFLOWS: 'developers',
  BATCH_REFUNDS: 'refunds',
  STATUS_PAGE: 'downtimes',
  EMBEDDABLE_COMPONENTS: 'embedded_components',
  VBA_CONFIGURATION: 'vba',
  ROUTER: 'flowwise',
  GATEWAY_PLUS: 'flowwise',
  ROUTER_ANALYTICS: 'flowwise',
  PAYMENT_VERIFICATION: 'payments',
  PAYMENT_VERIFICATION_DETAILS: 'payments',
  WALLET_DETAILS: 'payments',
  QR_CODE: 'payment_buttons',
};

/** FormController screens for login / signup / remaining auth. */
export const AUTH_COMPONENTS: ReadonlySet<string> = new Set(
  Object.entries(CONTAINER_MODULE_MAP)
    .filter(([, sentryModule]) =>
      sentryModule === 'auth' ||
      sentryModule === 'login' ||
      sentryModule === 'signup',
    )
    .map(([componentName]) => componentName),
);
